import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import CommandPalette from "../components/CommandPalette";

const PaletteContext = createContext(null);

export function PaletteProvider({ children }) {
  const [open, setOpen] = useState(false);

  const toggle = useCallback(() => setOpen((o) => !o), []);
  const openPalette = useCallback(() => setOpen(true), []);
  const closePalette = useCallback(() => setOpen(false), []);

  useEffect(() => {
    const handler = (e) => {
      const isCmdK = (e.metaKey || e.ctrlKey) && (e.key === "k" || e.key === "K");
      if (isCmdK) {
        e.preventDefault();
        toggle();
        return;
      }
      // "/" opens the palette when not typing in a field
      if (e.key === "/" && !open) {
        const tag = (e.target && e.target.tagName) || "";
        const editable = e.target && e.target.isContentEditable;
        if (tag !== "INPUT" && tag !== "TEXTAREA" && tag !== "SELECT" && !editable) {
          e.preventDefault();
          openPalette();
        }
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [toggle, openPalette, open]);

  const value = useMemo(
    () => ({ open, openPalette, closePalette, toggle }),
    [open, openPalette, closePalette, toggle]
  );

  return (
    <PaletteContext.Provider value={value}>
      {children}
      <CommandPalette open={open} onOpenChange={setOpen} />
    </PaletteContext.Provider>
  );
}

export function usePalette() {
  const ctx = useContext(PaletteContext);
  if (!ctx) throw new Error("usePalette must be used within PaletteProvider");
  return ctx;
}
